import { Form, FormInstance, Input, Modal, message } from "antd";
import { useForm } from "antd/lib/form/Form";
import { forwardRef, useImperativeHandle, useState } from "react";
import { AuthApi } from "../../client/Api";
import Cookies from "js-cookie";
import { max, min, required } from "../../helpers/FormRuleHelper";

export interface IProfileUpdateModalRefMethods {
  setOpen: (open: boolean) => void;
  form: FormInstance;
}

const ProfileUpdateModal = forwardRef((_, ref) => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    setOpen: setOpen,
    form: form,
  }));

  const onCancel = () => {
    setOpen(false);
    form.resetFields();
  };

  return (
    <Modal
      title="Profili Güncelle"
      open={open}
      confirmLoading={loading}
      onCancel={onCancel}
      onOk={() =>
        form.validateFields().then((values) => {
          setLoading(true);
          AuthApi.profileUpdate(values)
            .then((response) => {
              Cookies.set("user", JSON.stringify(response.user), {
                expires: 365,
              });
              message.success(response.message);
              onCancel();
              window.location.reload();
            })
            .finally(() => setLoading(false));
        })
      }
      cancelText="Vazgeç"
      okText="Güncelle"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="İsim Soyisim"
          name="fullName"
          rules={[required, min(10), max(255)]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="E-Posta" name="email">
          <Input disabled />
        </Form.Item>
      </Form>
    </Modal>
  );
});

export default ProfileUpdateModal;
